import { string } from 'yup';
const phoneValidator = string().matches(/^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/, 'Invalid phone number');
export default phoneValidator;
//# sourceMappingURL=index.js.map